import { ShieldCheck, Wrench, QrCode, ShieldAlert } from "lucide-react";
import { fmtDate } from "../../lib/format";
import { downloadUrl } from "../../lib/api";

const TONES = {
  sky: { box: "border-sky-300 bg-sky-50", icon: "text-sky-700", text: "text-sky-900" },
  amber: { box: "border-amber-300 bg-amber-50", icon: "text-amber-700", text: "text-amber-900" },
  rose: { box: "border-rose-300 bg-rose-50", icon: "text-rose-700", text: "text-rose-900" },
};

// 30 gün içinde / geçmiş tarihli hatırlatma şeridi (garanti, bakım, sigorta); isme tıklayınca kart düzenlemeye açılır
function DueBanner({ testid, rowPrefix, tone, Icon, title, message, items, dateOf, daysOf, onOpen, tagOf }) {
  const t = TONES[tone];
  return (
    <div className={`rounded-lg border ${t.box} px-4 py-3 flex items-start gap-3`} data-testid={testid}>
      <Icon className={`w-4 h-4 ${t.icon} mt-0.5 shrink-0`} />
      <div className={`text-xs ${t.text} flex-1`}>
        <span className="font-bold uppercase">{title}</span> {message}
        <ul className="mt-1 space-y-0.5">
          {items.slice(0, 6).map((d) => {
            const [cls, txt] = daysOf(d.days_left);
            return <li key={d.key || d.id} data-testid={`${rowPrefix}-${d.key || d.id}`}><button type="button" onClick={() => onOpen(d.id)} className="font-semibold hover:underline">{d.name}</button>{d.serial_no ? ` (${d.serial_no})` : ""}{tagOf && <span className="ml-1 px-1.5 py-0.5 rounded bg-white/80 border border-current text-[10px] font-bold uppercase">{tagOf(d)}</span>} — {d.assignee_name || "zimmetsiz"} — {fmtDate(dateOf(d))} <b className={cls}>{txt}</b></li>;
          })}
          {items.length > 6 && <li>+{items.length - 6} kayıt daha</li>}
        </ul>
      </div>
    </div>
  );
}

const warrantyDays = (n) => (n < 0 ? ["text-slate-500", `${-n} gün önce bitti`] : ["text-red-700", `${n} gün kaldı`]);
const maintDays = (n) => (n < 0 ? ["text-red-700", `${-n} gün gecikti`] : ["", `${n} gün kaldı`]);

export function WarrantyBanner({ items, onOpen }) {
  if (!items.length) return null;
  return <DueBanner testid="warranty-due-banner" rowPrefix="warranty-due" tone="sky" Icon={ShieldCheck} title="Garanti hatırlatması:" message={`${items.length} demirbaşın garantisi 30 gün içinde bitiyor veya bitti.`} items={items} dateOf={(d) => d.warranty_end} daysOf={warrantyDays} onOpen={onOpen} />;
}

// DASK / konut / trafik / kasko poliçeleri — poliçe başına satır
export function InsuranceBanner({ items, onOpen }) {
  if (!items.length) return null;
  return <DueBanner testid="insurance-due-banner" rowPrefix="insurance-due" tone="rose" Icon={ShieldAlert} title="Sigorta hatırlatması:" message={`${items.length} poliçe (DASK / konut / trafik / kasko) 30 gün içinde bitiyor veya bitti.`} items={items} dateOf={(d) => d.end_date} daysOf={warrantyDays} onOpen={onOpen} tagOf={(d) => d.label} />;
}

export function MaintenanceDueBanner({ items, onOpen }) {
  if (!items.length) return null;
  return <DueBanner testid="maintenance-due-banner" rowPrefix="maintenance-due" tone="amber" Icon={Wrench} title="Bakım hatırlatması:" message={`${items.length} demirbaşın sonraki bakım tarihi 30 gün içinde veya geçmiş.`} items={items} dateOf={(d) => d.next_maintenance_date} daysOf={maintDays} onOpen={onOpen} />;
}

// seçili demirbaşlar için QR etiket çubuğu
export function QrBar({ qrSel, setQrSel }) {
  if (!qrSel.length) return null;
  return (
    <div className="sticky top-2 z-10 rounded-lg border border-slate-800 bg-slate-900 text-white px-4 py-2.5 flex items-center justify-between gap-3 shadow-lg" data-testid="qr-bar">
      <span className="text-xs font-semibold inline-flex items-center gap-2"><QrCode className="w-4 h-4" /> {qrSel.length} demirbaş seçildi — QR etiket (A4, 24 etiket/sayfa)</span>
      <div className="flex items-center gap-2">
        <button type="button" onClick={() => setQrSel([])} data-testid="qr-clear" className="px-2.5 py-1 rounded-md bg-white/15 hover:bg-white/25 text-xs font-semibold">Temizle</button>
        <a href={downloadUrl(`/fixed-assets/qr-labels?ids=${qrSel.join(",")}&origin=${encodeURIComponent(window.location.origin)}`)} target="_blank" rel="noreferrer" data-testid="qr-print" className="inline-flex items-center gap-1 px-3 py-1 rounded-md bg-amber-500 text-slate-900 text-xs font-bold hover:bg-amber-400"><QrCode className="w-3.5 h-3.5" /> QR Etiket Yazdır</a>
      </div>
    </div>
  );
}
